// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color } from "@awc/XDL/Utilities";
import { mergeWithCss } from "@awc/XDL/Utilities/mergeWithCss";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: StyledShadowBoxStyles;
    [key: string]: any;
}

export interface StyledShadowBoxStyles {
    container?: InjectableCss;
}

export const styledShadowBoxStyle = css`
    padding: 12px;
    background: ${color("common.white")};
    border: 1px solid ${color("primary")};
    box-shadow: 0 3px 3px 0 ${color("common.black", 0.3)};
`;

const styledShadowBoxStyles: StyledShadowBoxStyles = {
    container: {
        css: css`
            ${styledShadowBoxStyle}
        `,
    },
};

const StyledShadowBox: React.FC<OwnProps> = ({ children, extendedStyles, ...otherProps }) => {
    const [styles] = useState(() => mergeWithCss(styledShadowBoxStyles, extendedStyles));

    if (!React.Children.count(children)) {
        return null;
    }

    return (
        <StyledWrapper {...styles.container} data-test-selector="styled-box" {...otherProps}>
            {children}
        </StyledWrapper>
    );
};

export default StyledShadowBox;
